import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-blog-posts',
  templateUrl: './blog-posts.component.html',
  styleUrls: ['./blog-posts.component.scss']
})
export class BlogPostsComponent implements OnInit, OnDestroy {

  @ViewChild('mobileScrollContainer') mobileScrollContainer!: ElementRef<HTMLDivElement>;

  private scrollInterval: any;
  private currentIndex = 0;

  posts = [
    {
      img: 'https://res.cloudinary.com/pervolare-org/image/upload/q_auto/f_auto/v1776217408/TAS/home/Image-container_sidt8i.webp',
      title: 'Coberturas por Cancelación de Viajes',
      content: 'Conoce cómo proteger tu viaje ante imprevistos con coberturas por cancelación y viaja con tranquilidad.',
      url:"https://ec.traveler-assistance.com/blog/asistencia-viajero/asistencias-viaje-cancelacion-verano-ecuatorianos"
    },
    {
      img: 'https://res.cloudinary.com/pervolare-org/image/upload/q_auto/f_auto/v1776217408/TAS/home/image-5_corg0r.webp',
      title: 'Requisitos de la Unión Europea para Estudiantes',
      content: 'Descubre los requisitos clave para estudiar en la Unión Europea y prepárate para tu experiencia académica.',
      url:"https://ec.traveler-assistance.com/blog/asistencia-viajero/tramites-y-requisitos-para-estudiantes-en-la-union-europea"
    },
    {
      img: 'https://res.cloudinary.com/pervolare-org/image/upload/q_auto/f_auto/v1776217408/TAS/home/image-6_tlecgr.webp',
      title: 'Top 5: Mejores destinos para ir en verano',
      content: 'Explora los mejores destinos para viajar en verano y planifica unas vacaciones inolvidables.',
      url:"https://ec.traveler-assistance.com/blog/asistencia-viajero/viaja-por-europa-este-verano-los-destinos-mas-recomendados"
    },
  ];

  constructor() {}

  ngOnInit(): void {
    this.startAutoScroll();
  }

  ngOnDestroy(): void {
    this.stopAutoScroll();
  }

  private startAutoScroll(): void {
    this.scrollInterval = setInterval(() => {
      this.scrollNext();
    }, 4000);
  }

  private stopAutoScroll(): void {
    if (this.scrollInterval) {
      clearInterval(this.scrollInterval);
    }
  }

  private scrollNext(): void {
    const container = this.mobileScrollContainer?.nativeElement;
    if (!container) return;

    const cardWidth = container.firstElementChild
      ? (container.firstElementChild as HTMLElement).offsetWidth + 16
      : 300;

    this.currentIndex++;

    if (this.currentIndex >= this.posts.length) {
      this.currentIndex = 0;
      container.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      container.scrollTo({ left: this.currentIndex * cardWidth, behavior: 'smooth' });
    }
  }
}
